import { useState } from "react";
import { Modal, Button, Form, Input, Select, DatePicker } from "antd";
import { withRouter } from "react-router";
import { createAnnouncement } from "@api/notification/announcement";
import { SuccessNotification, ErrorNotification } from "../..";
import moment from "moment";

const initialState = {
  title: "",
  content: "",
  location: "",
  active: "",
  start: "",
  end: "",
};

const AnnouncementCreateModal = ({
  open,
  handleModalClick,
  fetchAnnouncements,
}) => {
  const [values, setValues] = useState(initialState);
  const [dateRange, setDateRange] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle announcement create
  const handleAnnouncementCreate = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Set start and end date from date range
    // Convert start and end dates mongoose Date format with the same time
    values.start = moment(dateRange[0]).toDate();
    values.end = moment(dateRange[1]).toDate();

    // Create a new announcement for the admin
    createAnnouncement(values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchAnnouncements();
        SuccessNotification("Announcement created successfully");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Create Announcement"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        width={600}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleAnnouncementCreate}
            loading={loading}
          >
            Create
          </Button>,
        ]}
      >
        <Form
          labelCol={{
            span: 5,
          }}
          wrapperCol={{
            span: 16,
          }}
        >
          {/* Title */}
          <Form.Item label="Title">
            <Input
              name="title"
              placeholder="Enter announcement title"
              onChange={handleFormChange}
              value={values.title}
              rules={[{ required: true }]}
            />
          </Form.Item>

          {/* Announcement Content */}
          <Form.Item label="Content">
            <Input
              name="content"
              placeholder="Enter announcement content"
              onChange={handleFormChange}
              value={values.content}
              rules={[{ required: true }]}
            />
          </Form.Item>

          {/* Announcement Location */}
          <Form.Item label="Location">
            <Select
              name="location"
              placeholder="Select announcement location"
              onChange={(val) => setValues({ ...values, location: val })}
              value={values.location}
              rules={[{ required: true }]}
            >
              <Select.Option value="client">Client</Select.Option>
              <Select.Option value="landing-page">Landing Page</Select.Option>
              <Select.Option value="widget">Widget</Select.Option>
            </Select>
          </Form.Item>

          {/* Announcement Active */}
          <Form.Item label="Active">
            <Select
              name="active"
              placeholder="Select announcement active status"
              onChange={(val) => setValues({ ...values, active: val })}
              value={values.active}
              rules={[{ required: true }]}
            >
              <Select.Option value={true}>True</Select.Option>
              <Select.Option value={false}>False</Select.Option>
            </Select>
          </Form.Item>

          {/* Announcement Timeline */}
          <Form.Item label="Timeline">
            <DatePicker.RangePicker
              name="dateRange"
              onChange={(date, dateString) => {
                setDateRange(dateString);
              }}
              defaultValue={[values.start, values.end]}
              autoFocus
              popupStyle={{
                height: "auto",
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
              style={{
                width: "100%",
              }}
              popupAlign={{
                offset: [0, 0],
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default withRouter(AnnouncementCreateModal);
